<template>
  <div class="qr-code-modal-content d-flex-all-center margin-center">
    <div v-if="type === 1">
      <img :src="qrCodeUrl" width="196" height="266" />
      <div class="margin-t-12">联采项目经理：{{ qrPersonName }}</div>
    </div>
    <div v-else>
      <div class="d-flex margin-b-46">
        <div
          class="d-flex-all-center"
          v-for="(item, index) in processList"
          :key="index"
        >
          <div class="blue-block">
            {{ index + 1 }}
          </div>
          <div>{{ item }}</div>
          <div class="across" v-if="index < processList.length - 1"></div>
        </div>
      </div>
      <div class="margin-b-12 margin-t-12">
        扫码添加运营经理微信,享受一对一服务!
      </div>
      <img :src="qrCodeUrl" width="196" height="266" />
      <div class="margin-t-12" v-if="qrPersonName">联采项目经理：{{ qrPersonName }}</div>
    </div>
  </div>
</template>

<script lang="js">
import { onMounted, ref } from "vue";
export default {
    name: "QrCodeModalContent",
    props: {
        qrCodeUrl: {
          type: String,
          default: "123",
        },
        type: {
          type: Number,
          default: 1,
        },
        qrPersonName: {
            type: String
        }
    },
  setup(props) {
    const supplierQuotationProcess = [
        '添加联采运营经理',
        '下载材料清单',
        '完成报价',
        '报价信息上传平方网'
    ];

    const purchasePlanProcess = [
      '添加联采运营经理', '填写采购计划', '确认联采方案'
    ];

    const processList = ref([]);

    onMounted(()=>{
      if (props.type === 2) {
        processList.value = supplierQuotationProcess;
      } else if (props.type === 3) {
        processList.value = purchasePlanProcess;
      }
    })

    return {
      supplierQuotationProcess,
      processList,
      purchasePlanProcess,
    };
  },
};
</script>

<style lang="scss" scoped>
.qr-code-modal-content {
  text-align: center;
  color: #1d2129;
  .blue-block {
    width: 24px;
    height: 24px;
    background: #165dff;
    border-radius: 4px;
    margin-right: 8px;
    color: #fff;
    text-align: center;
    line-height: 24px;
  }
  .across {
    width: 29px;
    height: 1px;
    background: #4d5968;
    margin: 0 6px;
  }
  .margin-b-46 {
    margin-bottom: 46px;
  }
}
</style>
